"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _PaymentCard = _interopRequireDefault(require("./PaymentCard"));
var _paymentTypes = require("../data/payment-types");
var _default = function _default(_ref) {
  var onPlanSelected = _ref.onPlanSelected;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    className: "modal-content payment-cards",
    stackable: true,
    columns: _paymentTypes.paymentTypes.length,
    verticalAlign: "top"
  }, _paymentTypes.paymentTypes.map(function (paymentType) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      className: "payment-column",
      key: _paymentTypes.paymentTypes.indexOf(paymentType)
    }, /*#__PURE__*/_react["default"].createElement(_PaymentCard["default"], (0, _extends2["default"])({}, paymentType, {
      onPlanSelected: onPlanSelected,
      index: _paymentTypes.paymentTypes.indexOf(paymentType)
    })));
  })));
};
exports["default"] = _default;